import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=d1b258fc&scoped=true"
import script from "./Tags.ts?vue&type=script&lang=ts&external"
export * from "./Tags.ts?vue&type=script&lang=ts&external"
import style0 from "./tags.scss?vue&type=style&index=0&id=d1b258fc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b258fc",
  null
  
)

export default component.exports